module.exports = __webpack_public_path__ + "static/img/dw01.9e4cb810.jpg";